// SEO landing path parser — /anaokul/{ilce}/{tip} formatında URL'leri
// filter state'ine map'ler ve <title> + <meta description> günceller.
//
// CRA + Vercel: bilinmeyen path'ler index.html'i serve eder (SPA fallback).
// Bu yüzden /anaokul/uskudar gibi path'ler bu component'e düşer.

import { CATS } from '../data/constants';

// /anaokul, /kres, /atolye gibi path prefixleri → kategori id eşleşmesi
const TYPE_SLUGS = {
  anaokul: 'anaokul',
  kres: 'kres',
  oyunevi: 'oyunevi',
  kurs: 'kurs',
  atolye: 'atolye',
  spor: 'spor',
  muzik: 'muzik',
};

// Path'i parse et: /anaokul/uskudar/montessori → { type, ilce, tag }
export function parseSeoPath(pathname) {
  if (!pathname || pathname === '/' || pathname.startsWith('/api/') || pathname.startsWith('/seo/'))
    return null;
  const parts = pathname.replace(/^\/+|\/+$/g, '').split('/');
  if (!parts.length) return null;
  const typeSlug = parts[0]?.toLowerCase();
  const type = TYPE_SLUGS[typeSlug];
  if (!type) return null;
  return {
    type,
    ilce: parts[1] ? decodeURIComponent(parts[1]).replace(/-/g, ' ') : null,
    tag: parts[2] ? decodeURIComponent(parts[2]).replace(/-/g, ' ') : null,
  };
}

// Sayfanın <title> ve meta description'ını dinamik güncelle (Google indexler)
export function applySeoMeta({ type, ilce, tag }) {
  const cat = CATS.find(c => c.id === type) || { label: type };
  const ilceCap = ilce ? ilce.charAt(0).toUpperCase() + ilce.slice(1).toLowerCase() : '';
  const tagCap = tag ? tag.charAt(0).toUpperCase() + tag.slice(1).toLowerCase() : '';

  const titleParts = [];
  if (tagCap) titleParts.push(tagCap);
  if (ilceCap) titleParts.push(ilceCap);
  titleParts.push(cat.label);
  titleParts.push('· OkulMap');
  document.title = titleParts.join(' ');

  const descParts = [];
  if (ilceCap) descParts.push(`${ilceCap}'da`);
  if (tagCap) descParts.push(tagCap);
  descParts.push(cat.label.toLowerCase());
  descParts.push('arayan veliler için OkulMap. Fiyat, yaş, mesafe, yorum ve veli puanlarına göre filtrele.');
  setMeta('description', descParts.join(' '));

  // Open Graph
  setMeta('og:title', document.title, true);
  setMeta('og:description', descParts.join(' '), true);
  setMeta('og:type', 'website', true);
  setMeta('og:url', window.location.href, true);

  // Canonical
  setLink('canonical', window.location.origin + window.location.pathname);
}

function setMeta(key, content, isProperty = false) {
  const attr = isProperty ? 'property' : 'name';
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}
